import React, { useState } from 'react';
import './Header5.css'; // Import your CSS file
import logosaars from '../../../assets/images/logo_sarsindialiaison.jpg'; // Import your logo image

const servicesData = [
  {
    category: 'Engineering',
    services: [
      { name: 'PESO', description: 'Petroleum and Explosives Safety Organization approvals.', link: '/peso' },
      { name: 'Architectural Plans', description: 'Plans for buildings and factories.', link: '/architectural-design' },
    ],
  },
  {
    category: 'Licensing',
    services: [
      { name: 'PESO', description: 'PESO-related licensing.', link: '/peso' },
      { name: 'FC (Forest Clearance)', description: 'Obtain forest clearance permits.', link: '/forest-clearance' },
      { name: 'EC (Environment Clearance)', description: 'Environmental clearances for projects.', link: '/environmental-clearance' },
      { name: 'CTE', description: 'Consent to Establish certification.', link: '/consent-to-establish' },
      { name: 'CTO', description: 'Consent to Operate certification.', link: '/consent-to-operate' },
      { name: 'Hazardous Waste', description: 'Handling hazardous waste approvals.', link: '/hazardous-waste-licensing' },
      { name: 'Bio-Medical Waste Authorization', description: 'Authorization for bio-medical waste management.', link: '/bio-medical-waste-authorization' },
      { name: 'Fire Licensing', description: 'Fire safety recommendation, certification.', link: '/fire-licensing' },
      { name: 'Clinical Establishment', description: 'Licensing and certification for clinical establishments.', link: '/clinical-establishment-licensing' },
    ],
  },
  {
    category: 'NOCs',
    services: [
      { name: 'Fire NOC', description: 'Fire safety NOC approvals.', link: '/fire-nocs' },
      { name: 'CGWA NOC', description: 'Central Ground Water Authority approvals.', link: '/cgwanoc' },
      { name: 'Airport Height Clearance NOC', description: 'The Airport Authority of India (AAI) approvals.', link: '/airport-height-clearance-noc' },
      { name: 'Water Allocation Order NOC', description: 'Ensure sustainable water use and comply with legal requirements through expert water allocation order NOC assistance.', link: '/water-allocation-order-noc' },
      { name: 'Various Govt Officials NOCs', description: 'Get assistance with obtaining necessary NOCs for smooth operations.', link: '/various-govt-officials-nocs' },
    ],
  },
  {
    category: 'Compliance and Audit',
    services: [
      { name: 'PESO Compliance', description: 'Ensure the safety, compliance, and smooth operations of your hazardous material handling facilities with our expert PESO services.', link: '/peso-compliance' },
      { name: 'Forest Clearance Compliance', description: 'Expert consultation for various approvals.', link: '/forest-clearance-compliance' },
      { name: 'Environmental Clearance Compliance', description: 'Expert guidance for obtaining environmental clearances and ensuring legal adherence.', link: '/environment-clearance-compliance' },
      { name: 'Consent to Operate (CTO) Compliance', description: 'Expert consultation for various approvals.', link: '/consent-to-operate-compliance' },
      { name: 'Central Ground Water Authority (CGWA) Compliance', description: 'Expert consultation for various approvals.', link: '/cgwa-compliance' },
    ],
  },
  {
    category: 'Miscellaneous',
    services: [
      { name: 'Feasibility Study for Construction', description: 'Evaluate the viability of your construction project with expert assistance.', link: '/feasibility-study-for-construction' },
      { name: 'Environmental Impact Assessment (EIA)', description: 'Ensure your project aligns with environmental regulations and promotes sustainability.', link: '/environment-impact-assessment' },
      { name: 'Tank Testing Certificate (Explosive)', description: 'Ensure the safety and compliance of tanks used for explosive materials with our expert services.', link: '/tank-testing-certificate' },
    ],
  },
];

const MegaMenuNavbar = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar_tt4">
      <div className="navbar-container_tt4">
        <div className="logo_tt4">
          <img src={logosaars} alt="SAARS India Liaison Logo" className="logo-img_tt4" />
        </div>
        <ul className="nav-links_tt4">
          <li><a href="/">Home</a></li>
          <li><a href="/about">About</a></li>
          <li 
            className="dropdown_tt4"
            onMouseEnter={() => setMenuOpen(true)} // Show the dropdown on hover
            onMouseLeave={() => setMenuOpen(false)} // Hide the dropdown when the mouse leaves
          >
            <a href="#;" aria-haspopup="true" aria-expanded={isMenuOpen ? "true" : "false"}>Services</a>
            {/* Mega Menu structure */}
            {isMenuOpen && (
              <div className="dropdown-menu22_tt4">
                {servicesData.map((category, index) => (
                  <div key={index} className="dropdown-category_tt4">
                    <h3>{category.category}</h3>
                    <ul>
                      {category.services.map((service, i) => (
                        <li key={i}>
                          <a href={service.link}>
                            <strong>{service.name}</strong>
                            <p>{service.description}</p>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}
          </li>
          <li><a href="/testimonials">Testimonials</a></li>
          <li><a href="/contact">Contact</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default MegaMenuNavbar;